import getCurrentPackageProperties from './current-package-properties';
import type { RootState } from '../types/store';
import type { HostingPackageProperties } from '../types/hosting-package';

function getCurrentPackageTrialStatus(state: RootState): HostingPackageProperties['trial'] | null {
  const currentPackageProperties = getCurrentPackageProperties(state);
  if (!currentPackageProperties) return null;

  return currentPackageProperties.trial;
}

export default getCurrentPackageTrialStatus;
